import http from "../../BaseServiceHttp";

class RejectService {
  submitReject(productionUnitId, rejectPayload) {
    return http.post(`/production-units/${productionUnitId}/manual-rejects`, rejectPayload);
  }
}

export default new RejectService();
